<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>Advanced Settings</h2>
          <div class="button-spinner-container">
            <button pButton class="p-button-success save-button" label="Save"
                    [disabled]="getSaveButtonDisabled() || saveSettingsLoading"
                    (click)="saveAdvancedSettings()"></button>
            <p-progressSpinner
              *ngIf="saveSettingsLoading"
              [style]="{'height': '3rem'}"
              strokeWidth="8">
            </p-progressSpinner>
          </div>
        </div>
      </ng-template>

      <p-tabView>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              General <i class="pi pi-fw pi-cog"></i>
            </span>
          </ng-template>
          <auto-advanced-general-settings
            *ngIf="advancedSettings"
            [data]="advancedSettings"
            [preCacheBusyInput]="preCacheBusy"
            (dataEmitter)="onGeneralFormGroupInitialized($event)"
            (preCacheRequested)="onPreCacheRequested()">
          </auto-advanced-general-settings>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              Offer Sets <i class="pi pi-fw pi-cog"></i>
            </span>
          </ng-template>
          <auto-advanced-offer-set-configuration
            *ngIf="advancedSettings"
            [data]="advancedSettings"
            (dataEmitter)="onAdConfigFormGroupInitialized($event)">
          </auto-advanced-offer-set-configuration>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              Page Management <i class="pi pi-fw pi-file"></i>
            </span>
          </ng-template>
          <auto-advanced-page-configuration
            *ngIf="advancedSettings"
            [data]="advancedSettings"
            (dataEmitter)="onPageConfigFormGroupInitialized($event)">
          </auto-advanced-page-configuration>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              Lead Management <i class="pi pi-fw pi-users"></i>
            </span>
          </ng-template>
          <auto-advanced-lead-management
            *ngIf="advancedSettings"
            [data]="advancedSettings"
            (dataEmitter)="onLeadManagementFormGroupInitialized($event)">
          </auto-advanced-lead-management>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>
              Service Categories <i class="pi pi-fw pi-list"></i>
            </span>
          </ng-template>
          <auto-advanced-service-categories
            *ngIf="advancedSettings"
            [data]="advancedSettings"
            (dataEmitter)="onServiceCategoriesFormGroupInitialized($event)">
          </auto-advanced-service-categories>
        </p-tabPanel>
      </p-tabView>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
